import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { StockAddressingInBatchState, StockAddressingStatus } from './StockAddressingInBatchTypes'

const selectFeature = (state: State) => state.stockAddressingInBatch

export const selectStockAddressing = createSelector(
  selectFeature,
  (state: StockAddressingInBatchState) => state.uploadFilePage.stockAddressing,
)

export const selectStockAddressingFile = createSelector(
  selectFeature,
  (state: StockAddressingInBatchState) => state.uploadFilePage.stockAddressingFile,
)

export const selectFileInvalidStructure = createSelector(
  selectFeature,
  (state: StockAddressingInBatchState) => state.uploadFilePage.invalidStructure,
)

export const selectSalesChannelsByFC = createSelector(
  selectFeature,
  (state: StockAddressingInBatchState) => state.uploadFilePage.salesChannelsByFC,
)

export const selectSelectedSalesChannels = createSelector(
  selectFeature,
  (state: StockAddressingInBatchState) => state.uploadFilePage.selectedSalesChannels,
)

export const selectFileResultAvailable = createSelector(
  selectFeature,
  (state: StockAddressingInBatchState) => state.uploadFilePage.stockAddressing?.id
    && state.uploadFilePage.stockAddressing.status === StockAddressingStatus.INVALID,
)

export const selectAddressing = createSelector(
  selectFeature,
  (state: StockAddressingInBatchState) => state.uploadFilePage.stockAddressing,
)
